
export const reducerWeekRemove = (state) => {
    return {
        ...state,
        weeks: state.weeks-1,
    }
}